export const ErrorCode = {
  Unauthorized: 'UNAUTHORIZED',
  Forbidden: 'FORBIDDEN',
  InvalidSessionId: 'INVALID_SESSION_ID',
  NotFound: 'NOT_FOUND',
  RetryableError: 'RETRYABLE_ERROR',
  NonRetryableError: 'NON_RETRYABLE_ERROR',
  ExternalError: 'EXTERNAL_ERROR',
  ValidationError: 'VALIDATION_ERROR',
  IllegalState: 'ILLEGAL_STATE',
  OtherNonTechnical: 'OTHER_NON_TECHNICAL', // 'edunvalvonnassa', deceased, blocked, etc
  InvalidPhoneNumber: 'INVALID_PHONE_NUMBER',
  NoAllowedReceivers: 'NO_ALLOWED_RECEIVERS',
  VerificationCodeInvalid: 'VERIFICATION_CODE_INVALID',
  VerificationCodeExpired: 'VERIFICATION_CODE_EXPIRED',
  TooManyAttempts: 'TOO_MANY_ATTEMPTS',
  BookMeeting: 'BOOK_MEETING',
  ContentError: 'CONTENT_ERROR',
  UserWithoutDomesticAddress: 'USER_WITHOUT_DOMESTIC_ADDRESS',
  ServiceAlreadySubscribed: 'SERVICE_ALREADY_SUBSCRIBED',
} as const

export type ErrorCode = (typeof ErrorCode)[keyof typeof ErrorCode]
